export default "__VITE_ASSET__OHQOHLk9__"